const pwa = {
  installTitle: "Install GAM CC",
  installDescription: "Get quick access from your home screen — works offline too",
  installButton: "Install",
  iosShareGuide: "Tap the Share button, then \"Add to Home Screen\"",
  offlineTitle: "No Internet Connection",
  offlineDescription: "This page is not available offline. Check your internet connection and try again.",
  offlineRetry: "Retry",
  pushEnable: "Enable notifications",
  pushDisable: "Disable notifications",
  pushEnabled: "Notifications enabled",
  pushNotSupported: "Notifications not supported in this browser",
  pushBlocked: "Notifications blocked — allow in browser settings",
  installationStatus: "Installation Status",
  installedStandalone: "Installed (Standalone)",
  runningInBrowser: "Running in Browser",
  installApp: "Install App",
  iosInstallHint: "In Safari: tap Share → Add to Home Screen",
  appName: "App Name",
  appDescription: "Description",
  pushNotifications: "Push Notifications",
  pushPermission: "Notification Permission",
  permGranted: "Granted",
  permDenied: "Denied",
  permPrompt: "Prompt",
  permUnsupported: "Unsupported",
  enablePush: "Enable Notifications",
  disablePush: "Disable Notifications",
  sendTestPush: "Send Test Notification",
  testPushSent: "Test notification sent",
  notificationTemplates: "Notification Templates",
  templateStatus: "Status Update",
  templateMention: "Mention",
  templateDeadline: "Deadline",
  templateAi: "AI Response",
  templateTitle: "Title",
  templateBody: "Body",
  templateVars: "Variables: {{project}}, {{user}}, {{date}}",
  notifPreferences: "Notification Preferences",
  notifWhatsapp: "WhatsApp",
  notifPhone: "Calls",
  notifSms: "SMS",
  notifEmail: "Email",
  notifNote: "Notes",
  notifReminder: "Reminders",
  notifSync_summary: "Sync",
  cameraScanner: "Camera & Scanner",
  cameraPermission: "Camera Permission",
  requestCamera: "Request Permission",
  scanQR: "Scan QR",
  scanResult: "Scan Result",
  takePhoto: "Take Photo",
  photoPreview: "Preview",
  clearPhoto: "Clear",
  contacts: "Contacts",
  contactsSupported: "Supported",
  contactsNotSupported: "Not supported in this browser",
  contactsHint: "Contact Picker API is only available in Chrome Android",
  importContacts: "Import Contacts",
  contactName: "Name",
  contactEmail: "Email",
  contactPhone: "Phone",
  noContacts: "No contacts imported",
  clearContacts: "Clear List",
  deviceCapabilities: "Device Capabilities",
  webShare: "Web Share",
  testShare: "Test Share",
  wakeLock: "Wake Lock",
  wakeLockActive: "Screen will stay on",
  vibration: "Vibration",
  testVibration: "Test Vibration",
  geolocation: "Geolocation",
  getLocation: "Get Location",
  badgeApi: "Badge API",
  backgroundSync: "Background Sync",
  serviceWorkerStatus: "Service Worker",
  supported: "Supported",
  notSupported: "Not Supported",
  active: "Active",
  inactive: "Inactive",
  pushAdmin: "Push Subscribers Admin",
  subscriberEmail: "Email",
  subscriberDate: "Subscribed",
  subscriberLastActive: "Last Active",
  sendToUser: "Send",
  sendToAll: "Send to All",
  cleanExpired: "Clean Expired",
  cleaning: "Cleaning...",
  cleaned: "Cleaned",
  noSubscribers: "No push subscribers yet",
  loading: "Loading...",
} as const;
export default pwa;
